import { useRef } from 'react';
import { GrBackTen, GrForwardTen } from 'react-icons/gr';
import {
  AudioContainer,
  DesktopButtonWrapper,
  MobileButtonsContainer,
  AudioPlayer,
  IconButton,
} from './styles';

const Audio = ({ children, ...rest }) => {
  const audioRef = useRef(null);

  const handleBackward = () => {
    audioRef.current.currentTime -= 10;
  };

  const handleForward = () => {
    audioRef.current.currentTime += 10;
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  return (
    <>
      {/* Botões do MobileContainer mostram quando largura da tela <= 640px, desktop > 640px */}
      <AudioContainer>
        <DesktopButtonWrapper>
          <IconButton type="button" onClick={handleBackward}>
            <GrBackTen size={40} />
          </IconButton>
        </DesktopButtonWrapper>

        <AudioPlayer {...rest} controlsList="nodownload noplaybackrate" ref={audioRef} onContextMenu={handleContextMenu}>
          {children}
        </AudioPlayer>

        <DesktopButtonWrapper>
          <IconButton type="button" onClick={handleForward}>
            <GrForwardTen size={40} />
          </IconButton>
        </DesktopButtonWrapper>

        <MobileButtonsContainer>
          <IconButton type="button" onClick={handleBackward}>
            <GrBackTen />
          </IconButton>
          <IconButton type="button" onClick={handleForward}>
            <GrForwardTen />
          </IconButton>
        </MobileButtonsContainer>
      </AudioContainer>
    </>
  );
};

export default Audio;
